export const STORE_DOMAIN_KEY = 'store';
